<!-------品目操作弹窗-------->
<template>
  <el-dialog
    v-loading="loading"
    :title="title"
    :visible.sync="showDialog"
    width="50rem"
    :before-close="closeDialog"
    class="dialog"
    top="5vh"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    append-to-body
    z-index="1000"
  >
    <div class="flex-center">
      <el-form
        ref="itemForm"
        size="small"
        label-width="150px"
        style="width: 90%"
        :model="itemForm"
        :rules="formRules"
        label-suffix="："
        :class="{ 'detail-form': readOnly }"
      >
        <el-form-item label="品目名称" prop="materielName">
          <el-input
            v-if="!readOnly"
            v-model="itemForm.materielName"
            placeholder="请输入品目名称"
            maxlength="100"
            show-word-limit
          />
          <span v-else>{{ itemForm.materielName || '-' }}</span>
        </el-form-item>
        <el-form-item label="计划采购数量" prop="materielNum">
          <el-input-number
            v-if="!readOnly"
            v-model="itemForm.materielNum"
            class="left-input-number"
            :min="0"
            :max="9999999999"
            :precision="2"
            placeholder="请输入数量"
            :controls="false"
            style="width: 100%"
          />
          <span v-else>{{ strToThousands(itemForm.materielNum || 0) || '-' }}</span>
        </el-form-item>
        <el-form-item label="单位" prop="materielUnit">
          <el-select
            v-if="!readOnly"
            v-model="itemForm.materielUnit"
            filterable
            allow-create
            default-first-option
            placeholder="请输入单位"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <span v-else>{{ itemForm.materielUnit || '-' }}</span>
        </el-form-item>
        <el-form-item label="计划采购金额(万元)" prop="budgetTotalPrice">
          <el-input-number
            v-if="!readOnly"
            v-model="itemForm.budgetTotalPrice"
            class="left-input-number"
            placeholder="请输入计划采购金额"
            :min="0"
            :max="99999999999"
            :precision="4"
            :controls="false"
            style="width: 100%"
          />
          <span v-else>{{ strToThousands(itemForm.budgetTotalPrice || 0) || ' - ' }}</span>
        </el-form-item>
        <el-form-item label="需求描述" prop="remarks">
          <el-input
            v-if="!readOnly"
            v-model.trim="itemForm.remarks"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 11 }"
            maxlength="200"
            show-word-limit
          />
          <span v-else>{{ itemForm.remarks || '-' }}</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">
        取 消
      </el-button>
      <el-button v-if="!readOnly" type="primary" size="medium" @click="submit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { unitOptions } from '@/dictionary/project/common'
import { cloneDeep } from 'lodash'

// 工具
import { strToThousands } from '@/utils/utils'

export default {
  data() {
    return {
      strToThousands,

      loading: false,
      showDialog: false,
      unitOptions, // 品目单位数据字典

      title: '',
      readOnly: false, // 是否只读

      // 表单
      itemForm: {
        materielName: '',
        materielNum: undefined,
        budgetTotalPrice: undefined,
        materielUnit: '',
        remarks: ''
      }
    }
  },

  computed: {
    formRules() {
      return this.readOnly
        ? {}
        : {
          materielName: [
            {
              required: true,
              message: '请输入品目名称',
              trigger: ['blur', 'change']
            }
          ],
          materielNum: [
            {
              required: true,
              message: '请输入品目数量',
              trigger: ['blur', 'change']
            },
            {
              pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
              message: '请输入仅包含小数点两位的有效数字',
              trigger: 'blur'
            }
          ],
          materielUnit: [
            {
              required: true,
              message: '请输入单位',
              trigger: ['blur', 'change']
            }
          ]
        }
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open(data = {}, readOnly = false) {
      this.itemForm = { ...this.itemForm, ...data }
      this.showDialog = true
      this.readOnly = readOnly
      this.title = this.readOnly ? '查看' : '设置品目'
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.$refs.itemForm.resetFields()
      this.showDialog = false
    },

    /**
     * 提交表单
     */
    submit() {
      this.$refs.itemForm.validate().then(valid => {
        if (!valid) return
        this.$emit('refresh', cloneDeep(this.itemForm))

        this.closeDialog()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.dialog {
  ::v-deep .el-dialog--center .el-dialog__body {
    padding-bottom: 0;
  }

  ::v-deep .el-input-number {
    .el-select {
      width: 100%;
    }
    &.left-input-number {
      .el-input__inner {
        text-align: left;
      }
      input::placeholder {
        text-align: left !important;
      }
    }
  }
}
</style>
